<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/xTIJFK/images/9780446574907.jpg?1733085690135" alt="This image is the cover for the book Montana Glory"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Montana Glory
      </h1>
      <p class="bookDescription body article font2">
        <p>The last thing in the world Zane McCord wants is a wife.  But after returning home to the family ranch in Montana to help his cousins search for the lost treasure that is their legacy, Zane can't help notice that love and marriage seem to be contagious. Both his cousins have succumbed, but he refuses. Determined to stay a bachelor till he dies, Zane wants to devote his time to filming documentaries and taking care of the ranch...and then Riley Mason walks into his life.<br/><br/> The last thing on Riley Mason's mind is romance. Sent to the McCord ranch to save the family's accounting problems, she only wants to impress her firm in Helena and be on her way. Life as a single mother isn't easy and she needs to impress her bosses for a raise. But when Zane McCord opens the door, her breath catches in her throat and a desire she's never experienced before takes over her. When the McCords insist that she and her daughter, Summer stay at the ranch, she's forced to give in and before long, she's pulled into their search for the long lost treasure.  But she absolutely draws the line at getting involved with Zane McCord, playboy and heartbreaker extraordinaire. <br/><br/> But as they all get closer to finding Coot's lost treasure, a dangerous series of accidents target Riley and her daughter Summer. Can Zane keep her safe while trying to win her heart?</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        R.C. Ryan
      </h2>
      
      <p class="authorDescription body article"><I>New York Times</I> bestselling author <B>R.C. Ryan</B> has written more than ninety novels, both contemporary and historical.  Quite an accomplishment for someone who, after her fifth child started school, gave herself the gift of an hour a day to follow her dream to become a writer. <br><br> In a career spanning more than twenty years, Ms. Ryan has given dozens of radio, television, and print interviews across the country and Canada, and has been quoted in such diverse publications as the <I>Wall Street Journal</I> and <I>Cosmopolitan</I>.  She has also appeared on <I>CNN News</I> and <I>Good Morning America</I>. <br><br> R.C. Ryan is a pseudonym of <I>New York Times</I> bestselling author Ruth Ryan Langan.<br><br> You can learn more about R. C. Ryan and her alter ego Ruth Ryan Langan at:<br> RyanLangan.com<br> Twitter, @RuthRyanLangan<br> Facebook.com</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Grand Central Publishing
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?16da7460